module.exports = __webpack_public_path__ + "img/person-active.5a0417ad.svg";